import { graphql } from '@api/generated';

export const ADD_FOLLOW_UP_INTERACTION_MUTATION = graphql(`
  mutation AddFollowUpInteraction(
    $followUpId: ID!
    $input: FollowUpInteractionInput!
  ) {
    addFollowUpInteraction(followUpId: $followUpId, input: $input) {
      id
      interactions {
        id
      }
    }
  }
`);
